import { Component, Input, OnInit } from '@angular/core';
import { PredictionsService } from 'app/services/predictions.service';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-prices-and-volatility',
  templateUrl: './prices-and-volatility.component.html',
  styleUrls: ['./prices-and-volatility.component.scss']
})
export class PricesAndVolatilityComponent implements OnInit {
  @Input() product: any;

  pricesChart: EChartsOption;
  
  constructor(private readonly predictionService: PredictionsService) { }

  ngOnInit(): void {
    this.predictionService.getTimeSeries(this.product.series, new Date(new Date().setFullYear(new Date().getFullYear() - 1)), new Date()).subscribe(response => {
      this.setChartOptions(response);
    })
  }

  private setChartOptions(data){
    var allDates: any[] = data.map(item => item.time);

    this.pricesChart = {
      tooltip: {
  
      },
      legend: {
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: { show: true }
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: allDates
        }
      ],
      yAxis: [
        {
          type: 'value',
        }
      ],
      series: [
        {
          data: data.map(item => [item.time, item.value]),
          type: 'line'
        }
      ]
      };

  }

}
